module.exports = __webpack_public_path__ + "static/media/mapaP1.ee4256da.jpg";